import { render, staticRenderFns } from "./MotionWrapper.vue?vue&type=template&id=6f362921"
import script from "./MotionWrapper.vue?vue&type=script&lang=js"
export * from "./MotionWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports